<script>
    import { createEventDispatcher } from 'svelte';

    import main from '../../state/main';
    import user from '../../state/user';

    const dispatch = createEventDispatcher();

    let signUpForm = {
        name: '',
        email: '',
        phone: '',
        pass: ''
    };
    let signUpSubmitting = false;
    let signUpError = '';

    let showForm = true;

    async function onSignUp() {
        signUpSubmitting = true;
        signUpError = '';
        let result = await user.signUp(signUpForm);
        signUpSubmitting = false;

        if (result) {
            alert('Rezervace byla dokončena, postupujte podle instrukcí v potvrzovacím emailu.');
            dispatch('close');
        } else {
            signUpError = 'Registrace se nezdařila!';
        }
    }

    async function checkUser(e) {
        let result = await user.getByEmail(signUpForm.email);

        showForm = !result;
    }

    function formatPhone(phone) {
        let out = [];

        // Remove formatting
        phone = phone.replace(/[^0-9+]/g, '');

        while (phone.length > 0) {
            // Consume up to 3 numbers from the end
            phone = phone.replace(/.{1,3}$/, part => {
                out.unshift(part);
                return '';
            });
        }

        return out.join(' ').replace('+ ', '+');
    }

    function cleanupPhone() {
        let phone = signUpForm.phone.replace(/[^0-9+]/, '');

        // TODO: More cleanup

        signUpForm.phone = formatPhone(phone);
    }
</script>

<style>
    .controls {
        position: absolute;
        bottom: 20px;
        z-index: 1;
    }
</style>

<form on:submit|preventDefault={onSignUp}>
    {#if signUpError}
        <article class="message is-danger">
            <div class="message-body">{signUpError}</div>
        </article>
    {/if}

    <div class="field">
        <label class="label" for="signUpEmail">Email</label>
        <div class="control">
            <input bind:value={signUpForm.email} on:change={checkUser} class="input" id="signUpEmail" type="email" placeholder="vas@email.cz" required>
        </div>
    </div>

    {#if showForm}
        <div class="field">
            <label class="label" for="signUpName">Jméno</label>
            <div class="control">
                <input bind:value={signUpForm.name} class="input" id="signUpName" type="text" placeholder="Vaše jméno" required>
            </div>
        </div>

        <div class="field">
            <label class="label" for="signUpPhone">Telefon</label>
            <div class="control">
                <input bind:value={signUpForm.phone} class="input" id="signUpPhone" type="text" placeholder="Telefonní číslo" on:change={cleanupPhone} maxlength="16" required>
            </div>
        </div>

        <div class="field">
            <label class="label" for="signUpPassword">Heslo</label>
            <div class="control">
                <input bind:value={signUpForm.pass} class="input" id="signUpPassword" type="password" placeholder="Vaše heslo" required>
            </div>
        </div>

        <small>Registrací souhlasíte se <a href="{$main.baseWeb}/vop#privacy" target="_blank">zpracováním osobních údajů</a></small>
    {:else}
        <div class="notification is-info">
            Na tento email již účet existuje, chcete se přihlásit ?
        </div>
    {/if}

    <div class="controls">
        <div class="buttons">
            {#if showForm}
                <button class="button is-success"
                        class:is-loading={signUpSubmitting}>
                    Registrovat
                </button>
            {:else}
                <button type="button" class="button is-success"
                        on:click|preventDefault={() => dispatch('switch', { tab: 'sign-in', email: signUpForm.email })}>
                    Přejít na přihlášení
                </button>
            {/if}

            <button type="button" class="button"
                    class:is-loading={signUpSubmitting}
                    on:click|preventDefault={() => dispatch('close')}>
                Zrušit
            </button>
        </div>
    </div>
</form>
